/* eslint-disable no-unused-vars */
import { attachmentCategory, RequestTypes, writingsOfJusticeEnum, casePartyRoleEnum, partyTypeEnum } from '@/helpers/enum';
import ar from '@/local/ar';
import globalStore from '@/store/index';

const namespace = 'CasesModule';

const store = (customNameSpace) => {
  return {
    state: globalStore.state[customNameSpace || namespace],
    getters: Object.keys(globalStore.getters)
      .reduce((obj, key) => {
        if (key.includes(customNameSpace || namespace + '/')) { obj[key.replace(customNameSpace || namespace + '/', '')] = globalStore.getters[key]; }
        return obj;
      }, {}),
    dispatch: (actionName, payload) =>
      globalStore.dispatch(`${customNameSpace || namespace}/${actionName}`, payload),
  };
};

export default {
  validateCaseRelatedRequest: payload =>
    new Promise((resolve, reject) => {
      const requestReasons = (payload.data.requestReasons || []).filter(r => !r.isDraft || r.checked);
      if (payload.data.requestType.showRequestReasonSection && requestReasons.length < 1) {
        reject(ar.caseRelatedRequest.errors.reasonsNumberError);
      }
      if (payload.data.requestType.id === (RequestTypes['add-representative'] || {}).id) {
        if (payload.data.representationInfoDetails.attorneyTypeId == writingsOfJusticeEnum.externalAttorney) {
          if (!payload.data.attachments.some(a => a.fileCategory === attachmentCategory.attorneyImage)) {
            reject(ar.caseRelatedRequest.errors.attorneyAttachmentNotFound);
          }
        }
        if (payload.data.representationInfoDetails.casePartyRole == casePartyRoleEnum.liquidator) {
          if (!payload.data.attachments.some(a => a.fileCategory === attachmentCategory.judgementImage)) {
            reject(ar.caseRelatedRequest.errors.judgementAttachmentNotFound);
          }
        }
        if (payload.data.representationInfoDetails.casePartyRole == casePartyRoleEnum.representative && !isCompanyType(payload.data.partyType)) {
          if (!payload.data.attachments.some(a => a.fileCategory === attachmentCategory.letterImage)) {
            reject(ar.caseRelatedRequest.errors.letterImageAttachmentNotFound);
          }
        }
      }
      resolve();
    }),
};

const isCompanyType = (partyTypeId) => {
  const companyTypes = {
    [partyTypeEnum.foreignCompany]: true,
    [partyTypeEnum.firm]: true,
    [partyTypeEnum.organization]: true,
  };
  return !!companyTypes[partyTypeId];
};
